import React, { useEffect, useState, useRef } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment-timezone";
import "react-big-calendar/lib/css/react-big-calendar.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import axios from 'axios';

const localizer = momentLocalizer(moment);

function WebinarMain() {
    const [webinars, setWebinars] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        country: '',
        state: '',
        city: '',
    });
    const eventDetailsRef = useRef(null);

    const handleCountryChange = (country) => {
        setSelectedCountry(country);
        setSelectedState(null); // Reset state when a new country is selected
        setSelectedCity(null); // Reset city when a new country is selected
        setFormData({ ...formData, country: country.label, state: '', city: '' });
    };

    const handleStateChange = (state) => {
        setSelectedState(state);
        setSelectedCity(null); // Reset city when a new state is selected
        setFormData({ ...formData, state: state.label, city: '' });
    };

    const handleCityChange = (city) => {
        setSelectedCity(city);
        setFormData({ ...formData, city: city.label });
    };

    useEffect(() => {
        const fetchMeetings = async () => {
            try {
                const response = await fetch(
                    `https://api.itrain.io/webinar/getWebinar`
                );
                if (!response.ok) throw new Error("Failed to fetch meetings");
                const data = await response.json();
                setWebinars(data);
                console.log("Webinars:", data);
                const webinarLink = data.joinUrl; // Assuming joinUrl is a property in the response data
                console.log("Webinar Link:", webinarLink); // You can use this link as needed
            } catch (error) {
                console.error("Error fetching meetings:", error);
            }
        };
        fetchMeetings();
    }, []);

    const events = webinars.map((webinar) => ({
        id: webinar._id,
        title: webinar.webinarTitle,
        start: new Date(webinar.date),
        end: new Date(new Date(webinar.date).getTime() + 60 * 60 * 1000),
        allDay: false,
        description: webinar.desc,
        location: webinar.location || "Online - Zoom",
        contact: webinar.contact || "contact@titatechnologies.com",
        webinarLink: webinar.joinUrl,
        timeZone: webinar.timeZone,
    }));

    const handleEventClick = (event) => {
        setSelectedEvent(event);
        if (eventDetailsRef.current) {
            eventDetailsRef.current.scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
                window.scrollBy(0, 20); // Scroll down an additional 20px
            }, 300); // Adjust the timeout as needed
        }
    };

    const handleCloseDetails = () => {
        setSelectedEvent(null);
    };

    const handleRegisterClick = () => {
        setShowForm(true);
    };

    const handleCloseForm = () => {
        setShowForm(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.email) {
            alert('Email is required');
            return;
        }

        if (!selectedEvent || !selectedEvent.webinarLink) {
            alert('No webinar link available for this event.');
            return;
        }
        
        const name = `${formData.firstName} ${formData.lastName}`;
        const emailData = {
            ...formData,
            name,
            webinarTitle: selectedEvent.title,
            webinarDate: moment(selectedEvent.start).format('MMMM Do YYYY'),
            webinarTime: `${moment(selectedEvent.start).format('h:mm A')} - ${moment(selectedEvent.end).format('h:mm A')}`,
            webinarLink: selectedEvent.webinarLink,
            webinarTimeZone: `${selectedEvent.timeZone.abbrev} - ${selectedEvent.timeZone.altName}`,
            webinarId: selectedEvent.id,
        };
        fetch('http://192.168.1.5:4000/webinarRegister/createWebinarRegister', {

            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(emailData),

        })
        
.then(response => response.json())
.then(data => {
    console.log('Success:', data);
    alert('email sent successfully');
    setShowForm(false);
})
.catch((error) => {
    console.error('Error:', error);
    alert('Failed to send registration');
});

        // console.log('Email Data:', emailData);
        // fetch('http://192.168.1.5:4000/send-email', {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(emailData),
        // })
        //     .then(response => response.json())
        //     .then(data => {
        //         console.log('Success:', data);
        //         alert('Email sent successfully');
        //         setShowForm(false);
        //     })
        //     .catch((error) => {
        //         console.error('Error:', error);
        //         alert('Failed to send email');
        //     });
    };

    return (
        <>
            <style>
                {`
                    .calendar-container {
                        background: white;
                        padding: 2rem;
                        border-radius: 10px;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
                        margin: 20px auto;
                        max-width: 90%;
                    }

                    .meeting-details {
                        margin: 20px auto;
                        padding: 20px;
                        background-color: white;
                        color: black;
                        border-radius: 10px;
                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
                        max-width: 500px;
                        text-align: left;
                    }

                    .meeting-details h2 {
                        color: #FF001E;
                        margin-bottom: 10px;
                    }

                    .meeting-details p {
                        margin: 5px 0;
                    }

                    .close-button {
                        background: none;
                        border: none;
                        color: #cc0000;
                        font-size: 1.2rem;
                        cursor: pointer;
                        float: right;
                    }

                    .register-button {
                        display: inline-block;
                        margin-top: 20px;
                        padding: 10px 20px;
                        background-color: #cc0000;
                        color: white;
                        font-size: 1rem;
                        border: none;
                        border-radius: 5px;
                        cursor: pointer;
                        transition: background 0.3s;
                    }

                    .register-button:hover {
                        background-color: #990000;
                    }

                    .modal {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0, 0, 0, 0.8);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 1000;
                    }

                    .modal-content {
                        background: rgba(255, 255, 255, 0.1);
                        backdrop-filter: blur(20px);
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        border-radius: 24px;
                        padding: 2rem;
                        color: white;
                        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
                        overflow: hidden;
                        transform: translateY(20px);
                        opacity: 0;
                        animation: slideIn 0.6s ease-out forwards;
                        width: 400px;
                        text-align: center;
                        position: relative;
                    }

                    @keyframes slideIn {
                        to {
                            transform: translateY(0);
                            opacity: 1;
                        }
                    }

                    .modal-content h2 {
                        margin-bottom: 20px;
                        color: white;
                    }

                    .modal-content input,
                    .modal-content textarea {
                        width: 100%;
                        margin: 10px 0;
                        padding: 10px;
                        border-radius: 8px;
                        border: 1px solid #ccc;
                        font-size: 1rem;
                    }

                    .modal-content button {
                        padding: 1rem;
                        background: #FF001E;
                        color: white;
                        border: none;
                        border-radius: 12px;
                        font-size: 1.2rem;
                        cursor: pointer;
                        transition: 0.3s;
                    }

                    .modal-content button:disabled {
                        background: #BDC3C7;
                        cursor: not-allowed;
                    }

                    .modal .close-form {
                        position: absolute;
                        top: 10px;
                        background-color: white;
                        right: 5px;
                        color: white;
                        background: none;
                        border: none;
                        font-size: 1rem;
                        cursor: pointer;
                    }

                    .event-info {
                        display: flex;
                        flex-direction: column;
                        gap: 10px; /* Space between items */
                        padding: 10px; /* Padding around the event info */
                        background-color: #f9f9f9; /* Light background for contrast */
                        border-radius: 8px; /* Rounded corners */
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow */
                    }

                    .event-detail {
                        display: flex;
                        align-items: center; /* Center icons and text vertically */
                        font-size: 1rem; /* Consistent font size */
                        color: #333; /* Darker text color for better readability */
                    }

                    .event-detail i {
                        margin-right: 8px; /* Space between icon and text */
                        color: #cc0000; /* Icon color */
                    }
                `}
            </style>
            <div className="calendar-container">
            <h2 style={{textAlign:"center"}}>Events <span className="hl">Calendar</span>   </h2>

                <div style={{ padding: '20px', border: '1px solid #ccc', marginBottom: '20px', borderRadius: '5px', backgroundColor: '#f9f9f9' }}>
                    <p>Step into the world of tech world with our expertly designed online IT courses. Whether you're just starting or know few things or an advanced learner, we've got something for you! Join our Online IT Courses and become job-ready in today's tech-driven world. Our virtual classrooms on IT training is designed to equip you with the skills you need to thrive in technology industry. Join our webinar by choosing your preferred date and time to get to know more about our offerings.</p>
                </div>

                <Calendar
                    localizer={localizer}
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 500 }}
                    onSelectEvent={handleEventClick}
                />
            </div>
            {selectedEvent && (
                <div className="meeting-details" ref={eventDetailsRef}>
                    <button
                        className="close-button"
                        onClick={handleCloseDetails}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                    <h2>{selectedEvent.title}</h2>
                    <div className="event-info">
                        <p className="event-detail">
                            <i className="fas fa-calendar-alt"></i>
                            <strong>Date:</strong>{" "}
                            {moment(selectedEvent.start).format("MMMM Do YYYY")}
                        </p>
                        <p className="event-detail">
                            <i className="fas fa-clock"></i>
                            <strong>Time:</strong>{" "}
                            {moment.tz(`${selectedEvent.start}`, selectedEvent.timeZone).format("h:mm A")} -{" "}
                            {moment.tz(`${selectedEvent.end}`, selectedEvent.timeZone).format("h:mm A")}{" "}
                            ({selectedEvent.timeZone})
                        </p>
                        <p className="event-detail">
                            <i className="fas fa-info-circle"></i>
                            <strong>Description:</strong>{" "}
                            {selectedEvent.description || "No description provided"}
                        </p>
                        <p className="event-detail">
                            <i className="fas fa-map-marker-alt"></i>
                            <strong>Location:</strong> {selectedEvent.location}
                        </p>
                        <p className="event-detail">
                            <i className="fas fa-envelope"></i>
                            <strong>Contact:</strong> {selectedEvent.contact}
                        </p>
                    </div>
                    <button
                        className="register-button"
                        onClick={handleRegisterClick}
                    >
                        <i className="fas fa-clipboard-check"></i> Register
                    </button>
                </div>
            )}

            {showForm && (
                <div className="modal">
                    <div className="modal-content">
                        <button className="close-form" onClick={handleCloseForm}>
                            &times;
                        </button>
                        <h2>Register for Webinar</h2>
                        <form onSubmit={handleSubmit}>
                            <input
                                type="text"
                                name="firstName"
                                placeholder="First Name"
                                value={formData.firstName}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                name="lastName"
                                placeholder="Last Name"
                                value={formData.lastName}
                                onChange={handleChange}
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                            <input
                                type="tel"
                                name="phone"
                                placeholder="Phone"
                                value={formData.phone}
                                onChange={handleChange}
                                style={{ marginBottom: '20px' }}
                            />
              <Select
                options={Country.getAllCountries().map((country) => ({
                    value: country.isoCode,
                    label: country.name,
                }))}
                value={selectedCountry}
                onChange={handleCountryChange}
                placeholder="Select Country"
                styles={customStyles}
            />

            {selectedCountry && (
                <Select
                    options={State.getStatesOfCountry(selectedCountry.value).map((state) => ({
                        value: state.isoCode,
                        label: state.name,
                    }))}
                    value={selectedState}
                    onChange={handleStateChange}
                    placeholder="Select State"
                    styles={customStyles}
                />
            )}

            {selectedState && (
                <Select
                    options={City.getCitiesOfState(selectedCountry.value, selectedState.value).map((city) => ({
                        value: city.name,
                        label: city.name,
                    }))}
                    value={selectedCity}
                    onChange={handleCityChange}
                    placeholder="Select City"
                    styles={customStyles}
                />
            )}

    
                           
                            <button type="submit">Submit</button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}

const customStyles = {
    container: (provided) => ({
        ...provided,
        marginBottom: '20px',
        borderRadius   : '12px',
        
    }),
    option: (provided) => ({
        ...provided,
        backgroundColor: 'white',
        color: 'black',
    }),
    menu: (provided) => ({
        ...provided,
        maxHeight: '150px',
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: '150px',
        overflowY: 'auto',
    }),

};

export default WebinarMain;